import { BranchPlatform, BranchType } from '@/view-models/branch'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { params, query } = to
  const route = to
  const store = nuxtApp.$store

  const hasGroupBooking = query.group_code && query.booking_time

  if (!hasGroupBooking && (store.state.groupOrderStatus || store.state.groupOrder?.group_code)) {
    store.dispatch('clearGroupOrder')
  }

  const isContainBranchPath = route.name?.includes('branches-id') || route.name?.includes('branch_id-branch')
  const isFunBookPath = route.name?.includes('funbook')
  if (!isContainBranchPath) {
    return
  }

  // FIXME: workaround, design debt of duplicate `_id`
  const bid = route.name?.startsWith('funbook') ? params.branch_id : params.id
  if (!bid) {
    return nuxtApp.runWithContext(() => navigateTo(`/`, { redirectCode: 302, replace: true }))
  }

  // 目前 funbook 1.0 皆轉為 funbook 2.0，網址全部導向 /funbook/:branch_id/branch
  if (to.name.includes('branches-id-funbook')) {
    const referer = to.query.referer || to.query.referer
    return nuxtApp.runWithContext(() =>
      navigateTo(nuxtApp.$localePath({ path: `/funbook/${to.params.id}/branch`, query: referer ? { referer } : {} }), {
        replace: true,
      })
    )
  }

  try {
    const branch = await store.dispatch('branch/getBranch', bid)
    const isBookingEngine = store.getters.isBookingEngine
    if (branch.platform === BranchPlatform.EzDing) {
      return nuxtApp.runWithContext(() => navigateTo('/'))
    }
    if (isBookingEngine) {
      await store.dispatch('branch/getBookingEngineBranchProducts', { bid, query: { for_booking_engine: true } })
      await store.dispatch('branch/getBranchFAQ', { bid })
      // 因為 JSON-LD 麵包屑需要 all regions, region, branch
      await store.dispatch('region/getRegion', branch.region_id)
      return
    }

    // only for funbook v1
    if (isFunBookPath && branch.funbook_ver === 1) {
      // branches/:id/funbook  FunBook Branch 樣式
      await store.dispatch('funbook/getBranchProducts', { bid: bid })
      return
    }

    // branches/:id  FunNow Branch 樣式
    const queryForBranchProducts = {
      size: 99,
    }

    if (hasGroupBooking) {
      Object.assign(queryForBranchProducts, {
        booking_time: query.booking_time,
        group_code: query.group_code,
        count: query.count,
      })
      store.dispatch('setGroupOrder', query)
    }

    const serviceQueue = [() => store.dispatch('branch/getBranchProducts', { bid, query: queryForBranchProducts })]

    if (!isFunBookPath) {
      // 因為 JSON-LD 麵包屑需要 all regions, region, branch
      serviceQueue.push(() => store.dispatch('region/getRegion', branch.region_id))
      serviceQueue.push(() => store.dispatch('branch/getBranchFAQ', { bid }))
    }

    await Promise.all(serviceQueue.map(service => service()))

    if (branch.type === BranchType.FunNow && isFunBookPath) {
      // branch type = 0 (FunNow) + branches/:id/funbook 需導至 branches/:id
      return nuxtApp.runWithContext(() => navigateTo(nuxtApp.$localePath({ name: 'branches-id', params: { id: bid }, query: { ...query } })))
    }

    if (branch.type === BranchType.FunBook && !isFunBookPath) {
      // branch type = 1 (FunBook) + branches/:id 需導至 branches/:id/funbook
      return nuxtApp.runWithContext(() => navigateTo(nuxtApp.$localePath({ name: 'branches-id-funbook', params: { id: bid }, query: { ...query } })))
    }
  } catch (err) {
    console.error('branches/_id', err)
    throw nuxtApp.runWithContext(() => showError({ statusCode: 404, message: 'Post not found', fatal: true }))
  }
})
